/**
 *
 */
define('common/config/params',{

    /**
     * Stubbed params
     */
    appType: 'desktop',

    // Set to one of the channels from piq constants
    piqChannel: '',

    // Paths are currently different for site and mobile
    images: {
        freeSpinSpriteImage: '',
        depositBonusImage: '',
        freeMoneyImage: '',
        bonusMoneyImage: ''
    },

    /**
     * Shared params
     */
    localStorageKeys: {
        debugModeEnabled: 'debugModeEnabled',
        sessionHistory: 'sessionHistory',
        showDisabledGames: 'showDisabledGames',
        testSubjectId: 'testSubjectId',
        lastPhoneVerificationOverlayDate: 'lastPhoneVerificationOverlayDate',
        tournamentCampaignOverride: 'tournamentCampaignOverride',
        olarkStorageKey: 'olarkStorageKey',
        gameLauncherStrategyOverride: 'GAMIFICATION:gameLauncher',
        adventureOverride: 'GAMIFICATION:adventureModel'
    },

    urls: {
        waitForTransactionUrl: '/api/common/query/payments/waitForTransaction/${ptx.id}'
    },

    bokuMoneyChoices: [
        {
            serviceKey: 'UK10',
            amount: 10
        },
        {
            serviceKey: 'UK20',
            amount: 20
        },
        {
            serviceKey: 'UK25',
            amount: 25
        },
        {
            serviceKey: 'UK30',
            amount: 30
        }
    ]
});

